app.filter('replace', function () {
    return function (value, keys) {
        if (!value) return
        return (keys || []).reduce(function (acc, item) {
            const re = new RegExp('\%' + item.key + '\%', 'g')
            return (acc || value).replace(re, item.value)
        }, '')
    };
});
